import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { DiagnosticBoundary } from './components/DiagnosticBoundary';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
      networkMode: 'always',
    },
  },
});

// Global handlers — if anything rejects outside React's render path, surface it
// in the console instead of letting it vanish into a silent spinner.
window.addEventListener('unhandledrejection', (ev) => {
  console.error('[global] unhandledrejection:', ev.reason);
});
window.addEventListener('error', (ev) => {
  console.error('[global] window error:', ev.message, ev.error);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProvider i18n={enTranslations}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <DiagnosticBoundary>
            <App />
          </DiagnosticBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </AppProvider>
  </React.StrictMode>,
);
